import React, { ReactNode, createContext, useContext, useMemo } from "react";

import { CIMasterRaw } from "@/domain/CIMaster";
import { useAdminAPI } from "../hooks";

const ctx = createContext<{
  ciMasters: CIMasterRaw[] | null;
  runReloadCIMasters: () => Promise<void>;
  isLoadedCIMasters: boolean;
}>({
  ciMasters: null,
  runReloadCIMasters: async () => {
    // nop
  },
  isLoadedCIMasters: false,
});

export const AdminCIMastersProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const {
    state: ciMasters,
    runReloadState: runReloadCIMasters,
    isLoadedState: isLoadedCIMasters,
  } = useAdminAPI<CIMasterRaw[]>("ciMasters");

  const ctxValue = useMemo(
    () => ({
      ciMasters,
      runReloadCIMasters,
      isLoadedCIMasters,
    }),
    [ciMasters, runReloadCIMasters, isLoadedCIMasters]
  );

  return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useAdminCIMasters = () => {
  return useContext(ctx);
};
